import { TGameAssignmentAction, GameAssignmentActionTypes } from './gameAssignmentActions';
import { IGameAssignmentState } from './gameAssignmentContext';

export const gameAssignmentReducer = (
	state: IGameAssignmentState,
	action: TGameAssignmentAction,
): IGameAssignmentState => {
	switch (action.type) {
		case GameAssignmentActionTypes.SET_GAMES_FOR_ASSIGN:
			return {
				...state,
				gamesForAssign: action.payload.gamesForAssign,
			};
		case GameAssignmentActionTypes.CHANGE_SEARCH_STRING:
			return {
				...state,
				searchString: action.payload.searchString,
				IDsSelectedGame: [],
				currentPage: 1,
			};
		case GameAssignmentActionTypes.CHANGE_SEARCH_STRING_FOR_ALL_CUSTOMERS:
			return {
				...state,
				searchStringForAllCustomers: action.payload.searchStringForAllCustomers,
			};
		case GameAssignmentActionTypes.CHANGE_SEARCH_STRING_FOR_RESTAURANTS:
			return {
				...state,
				searchStringForRestaurants: action.payload.searchStringForRestaurants,
			};
		case GameAssignmentActionTypes.CHANGE_SEARCH_STRING_FOR_GAMES:
			return {
				...state,
				searchStringForGames: action.payload.searchStringForGames,
			};
		case GameAssignmentActionTypes.SET_CATEGORY:
			return {
				...state,
				selectedCategory: action.payload.selectedCategory,
				IDsSelectedGame: [],
				isUnassignedGames: false,
				currentPage: 1,
			};
		case GameAssignmentActionTypes.SET_DEVELOPER:
			return {
				...state,
				selectedDeveloper: action.payload.selectedDeveloper,
				IDsSelectedGame: [],
				isUnassignedGames: false,
				currentPage: 1,
			};
		case GameAssignmentActionTypes.TOGGLE_UNASSIGNED_GAMES:
			return {
				...state,
				isUnassignedGames: !state.isUnassignedGames,
				currentPage: 1,
			};
		case GameAssignmentActionTypes.RESET_SELECTED_CONTROLS:
			return {
				...state,
				selectedCategory: null,
				selectedDeveloper: null,
				isUnassignedGames: false,
				IDsSelectedGame: [],
				currentPage: 1,
				searchString: '',
			};
		case GameAssignmentActionTypes.SET_SORT_BY:
			return {
				...state,
				sortBy: action.payload.sortBy,
				IDsSelectedGame: [],
			};
		case GameAssignmentActionTypes.SET_IDS_SELECTED_GAME:
			return {
				...state,
				IDsSelectedGame: action.payload.IDsSelectedGame,
			};
		case GameAssignmentActionTypes.CHANGE_ACTIVE_ITEM_TO_DISPLAY:
			return {
				...state,
				activeItemToDisplay: action.payload.activeItemToDisplay,
			};
		case GameAssignmentActionTypes.SET_SHOW_BREADCRUMBS:
			return {
				...state,
				isShowBreadcrumbs: action.payload.isShowBreadcrumbs,
			};
		case GameAssignmentActionTypes.SET_ALL_CUSTOMERS:
			return {
				...state,
				allCustomers: action.payload.allCustomers,
			};
		case GameAssignmentActionTypes.SET_IDS_SELECTED_CUSTOMERS:
			return {
				...state,
				IDsSelectedCustomers: action.payload.IDsSelectedCustomers,
				restaurants: action.payload.restaurants,
				IDsSelectedRestaurants: action.payload.IDsSelectedRestaurants,
				games: action.payload.games,
			};
		case GameAssignmentActionTypes.SET_IDS_SELECTED_RESTAURANTS:
			return {
				...state,
				IDsSelectedRestaurants: action.payload.IDsSelectedRestaurants,
				games: action.payload.games,
			};
		case GameAssignmentActionTypes.SET_GAMES:
			return {
				...state,
				games: action.payload.games,
				IDsSelectedGame: action.payload.IDsSelectedGame,
			};
		case GameAssignmentActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case GameAssignmentActionTypes.CHANGE_CURRENT_PAGE:
			return {
				...state,
				currentPage: action.payload.currentPage,
				IDsSelectedGame: [],
			};
		case GameAssignmentActionTypes.RESET_CHANGES:
			return {
				...state,
				activeItemToDisplay: 'customers',
				IDsSelectedCustomers: {},
				restaurants: [],
				IDsSelectedRestaurants: {},
				games: [],
				typeOfModalWindow: null,
			};
		default:
			return state;
	}
};
